<template>
  <BreadCrumb PageTitle="Nouveau Colis" />
  <NewColis />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import NewColis from "../../components/Colis/NewColis.vue";

export default defineComponent({
  name: "NewColisPage",
  components: {
    BreadCrumb,
    NewColis,
  },
});
</script>